import { thongKeSiSoActions } from './thongKeSiSoActions';
import { thongKeCSKHActions } from './thongKeCSKHActions';
import { thongKeCRMActions } from './thongKeCRMActions';

export const thongKeActionsWrapper = {
    thongKeSiSo: thongKeSiSoActions,
    thongKeCSKH: thongKeCSKHActions,
    thongKeCRM: thongKeCRMActions,
}

